import { useTranslation } from 'react-i18next';

import { Spinner } from '@/components/ui/spinner';

const Loading = (props: { label?: string }) => {
  const { t } = useTranslation();
  return (
    <div className="flex h-screen w-full items-center justify-center">
      <Spinner size="lg" aria-label={props.label || t('common.loading')} />
    </div>
  );
};

export default Loading;
